/**
 *
 * PageLayout
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { ImageSection, UserHeader } from "pickups-ui-library";
import { Container } from "reactstrap";
import { monthYear } from "utils/helpers";
import md5 from "md5";
import Navigation from "components/Navigation";

const PRIMARY_COLOR = process.env.REACT_APP_PRIMARY_COLOR;

function PageLayout(props) {
  const base = `https://www.gravatar.com/avatar/`;
  const { user } = props;
  const formattedEmail = ("" + user.email).trim().toLowerCase();
  const hash = md5(formattedEmail, { encoding: "binary" });
  const src = `${base}${hash}?d=mp`;

  return (
    <div>
      <Container style={{ marginTop: "1em" }}>
        <div className={"home-header"} />
        <UserHeader
          title={`${user.fname} ${user.lname}`}
          subTitle={`Donor Since ${monthYear(user.createdAt)}`}
          image={user.profileImage}
        />
      </Container>
      {props.children}
    </div>
  );
}

PageLayout.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(PageLayout);
